import * as Yup from 'yup'

import { EMPTY_OBJECT } from '../../../constants/common'
import { formatDateToApi, toUkTimezoneDate } from '../../../utils/date'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  REQUESTS_EDIT_DUE_DATE_FIELD_NAME,
  REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE,
} from './RequestEditDueDateModal.constants'

export function getRequestEditDueDateSubmitPayload(values, timezone) {
  return {
    [REQUESTS_EDIT_DUE_DATE_FIELD_NAME]: values[
      REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE
    ]
      ? null
      : formatDateToApi(values[REQUESTS_EDIT_DUE_DATE_FIELD_NAME], timezone),
  }
}

export function getRequestEditDueDateValidationSchema() {
  return Yup.object({
    [REQUESTS_EDIT_DUE_DATE_FIELD_NAME]: Yup.date().when(
      REQUESTS_EDIT_DUE_DATE_FIELD_NAME_WITHOUT_DATE,
      {
        is: value => !value,
        then: schema => schema.required(() => true),
      }
    ),
  })
}

export function getRequestEditDueDateProfileActionTypes() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return Object.values(actionTypeOptions).filter(item =>
    [
      EntityActionTypeSelectOptionValue.Edit,
      EntityActionTypeSelectOptionValue.RemoveAll,
    ].includes(item.value)
  )
}

export function getRequestEditDueDateWithActionTypesValidationSchema({
  itemAction = false,
} = EMPTY_OBJECT) {
  return Yup.object({
    [REQUESTS_EDIT_DUE_DATE_FIELD_NAME]: Yup.date()
      .nullable()
      .when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.required(() => true),
      }),
  })
}

export function getRequestEditDueDateWithActionTypesValidationSchemaCheckNoChanges({
  initialValues,
  itemAction,
  validationSchema,
}) {
  return validationSchema({ itemAction }).concat(
    formValidationSchemaNoChanged({
      initialValues,
    })
  )
}

export function getRequestEditDueDateInitialValues(value, timezone) {
  return {
    [REQUESTS_EDIT_DUE_DATE_FIELD_NAME]: value
      ? toUkTimezoneDate(value, timezone)
      : null,
  }
}

export function getRequestEditDueDateEmptyValues() {
  return getRequestEditDueDateInitialValues()
}

export function getRequestEditDueDateWithActionTypesInitialValues(
  value,
  timezone
) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...getRequestEditDueDateInitialValues(value, timezone),
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}
